import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { Consumer } from 'src/app/general/interfaces/functions';
import { SelectScheduleDialogComponent } from './select-schedule-dialog.component';
import { SelectScheduleDialogData } from '../util/interfaces';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public updateMenuEntrySchedule(): void {
//   const inputDialogData: SelectScheduleDialogData = {
//   }
//   this.selectScheduleDialogService.openEditor(
//     inputDialogData,
//     /* onUpdate */ outputDialogData => {
//       console.log(outputDialogData);
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class SelectScheduleDialogService {

  constructor(private dialog: MatDialog) { }

  public openEditor(inputDialogData: SelectScheduleDialogData, onUpdate: Consumer<SelectScheduleDialogData>) : CloseDialog {
    const dialogRef = this.dialog.open(SelectScheduleDialogComponent, {
      data: inputDialogData,
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(outputDialogData => {
      if (outputDialogData) {
        onUpdate(outputDialogData);
      }
    });

    return () => dialogRef.close();
  }
}
